import { AssignKioskRepository } from '../data/assign-kiosk-repository';
import { KioskLocation } from '../types/assign-kiosk-types';

export interface SaveRemoteStartMappingResult {
  hasError: boolean;
  errorMessage?: string;
}

export class SaveRemoteStartMappingUseCase {
  constructor(private readonly repository: AssignKioskRepository) {}

  async execute(machineId: string, location: KioskLocation): Promise<SaveRemoteStartMappingResult> {
    try {
      await this.repository.saveRemoteStartMapping(machineId, location);
      return { hasError: false };
    } catch (error) {
      const errorMessage = 'Unknown error occurred';
      return { hasError: true, errorMessage };
    }
  }
}
